var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1199_4250",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1199_4250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4131 6.50684L11.4023 6.49609V2.98047C11.4023 2.59669 11.5081 2.35467 11.6562 2.20801C11.8051 2.06076 12.0506 1.95612 12.4365 1.95605H17.6123C17.9753 1.95607 18.2209 2.0616 18.375 2.21484C18.5287 2.36776 18.6367 2.61322 18.6367 2.98047V10.3643C18.6367 10.7227 18.5329 10.9634 18.3848 11.1133C18.2371 11.2626 17.9999 11.3672 17.6436 11.3672H12.4053C12.0384 11.3672 11.803 11.2649 11.6592 11.1211C11.5154 10.9773 11.4131 10.7418 11.4131 10.375V6.50684Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9375 9.22461H8.21875C8.55742 9.22469 8.78767 9.32591 8.93262 9.4707C9.07761 9.6157 9.17969 9.84644 9.17969 10.1855V17.5908C9.17969 17.9749 9.07347 18.2205 8.92383 18.3701C8.77418 18.5197 8.52853 18.625 8.14453 18.625H2.96973C2.60673 18.625 2.36036 18.5198 2.20605 18.3672C2.05238 18.2152 1.94538 17.9729 1.94531 17.6123V10.2275C1.94532 9.86898 2.04903 9.62842 2.19727 9.47852C2.34489 9.32933 2.58148 9.22467 2.9375 9.22461Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94922 1.94531H8.21973C8.53704 1.94535 8.76889 2.04599 8.9209 2.19434C9.05372 2.32416 9.15023 2.51419 9.1748 2.76758L9.18066 2.87988V6.07227C9.18066 6.38264 9.08128 6.6019 8.93652 6.74414C8.7904 6.8877 8.56294 6.98698 8.24609 6.99121H5.15137V7.00195H2.93945C2.58333 7.00195 2.35053 6.89663 2.20605 6.74805C2.06021 6.59796 1.95703 6.35526 1.95703 5.98828V2.92773C1.95703 2.59476 2.06283 2.35744 2.21777 2.2041C2.37328 2.05032 2.61393 1.94537 2.94922 1.94531Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1191 13.5684L14.1084 13.5791H17.6328C17.9891 13.5791 18.2264 13.6837 18.374 13.833C18.5222 13.9829 18.626 14.2235 18.626 14.582V17.6426C18.626 17.9778 18.5217 18.2156 18.3691 18.3682C18.2166 18.5207 17.9788 18.625 17.6436 18.625H12.374C12.0437 18.625 11.811 18.523 11.6611 18.374C11.5297 18.2433 11.4331 18.0482 11.4082 17.7793L11.4023 17.6592V14.498C11.4023 14.1874 11.5024 13.9646 11.6484 13.8193C11.777 13.6917 11.9666 13.5984 12.2227 13.5742L12.3369 13.5684H14.1191Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhite);
export default __webpack_public_path__ + "static/media/dashboard_white.273044680a454393bbf652184f1ae019.svg";
export { ForwardRef as ReactComponent };